import { Reveal } from "./Reveal";
import { photoUrl } from "./Menus";

export default function Story({ heading = "", body = "", image = "" }) {
  const h = heading || "This is us";
  const b = body ||
    "Welcome to Harbour Haze – a family-owned café in the heart of our sunny seaside town, where great food, friendly faces, and good vibes come together.\n" +
    "We're passionate about serving exceptional coffee, refreshing drinks, and delicious homemade food, all made with care. Whether you're stopping by for a leisurely breakfast, a relaxed lunch, or just a catch-up over coffee, you'll always find a warm welcome waiting for you.\n" +
    "Come for the view, stay for the flavour, and leave feeling like part of the Harbour Haze family\n" +
    "Open 9.30am-10pm each day";

  return (
    <section id="story" className="max-w-7xl mx-auto px-5 md:px-8 py-24 md:py-32">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <Reveal className="lg:col-span-6 order-2 lg:order-1">
          <h2 className="font-head font-black tracking-tight leading-[0.95] text-4xl md:text-6xl">
            {h}
          </h2>
          <div className="mt-6 space-y-4 text-foreground/75 md:text-lg max-w-xl" data-testid="story-body">
            {b.split("\n").filter(Boolean).map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>
          <div className="mt-8 inline-flex items-center gap-3 bg-primary border-2 border-foreground rounded-full px-5 py-2.5 shadow-brutal">
            <span className="font-head font-extrabold text-sm md:text-base">↑ Just up the hill from the ferry</span>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="lg:col-span-6 order-1 lg:order-2">
          <div className="overflow-hidden rounded-2xl border-2 border-foreground shadow-brutal">
            <img src={image ? photoUrl(image) : "/team.webp"} alt="Harbour Haze Cafe Bar storefront" className="w-full h-[280px] md:h-[440px] object-cover object-center" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
